import React from 'react';
import PropTypes from 'prop-types';

export const OverviewTableCell = ({ value, suffix = '', displayFunction }) => {
    const valueToDisplay =
        typeof displayFunction === 'function' ? displayFunction(value) : value;

    return (
        <td className="overview-table__data">
            {valueToDisplay ? `${valueToDisplay}${suffix}` : '-'}
        </td>
    );
};

OverviewTableCell.propTypes = {
    value: PropTypes.any,
    suffix: PropTypes.string,
    displayFunction: PropTypes.func
};
